// extracted by mini-css-extract-plugin
export var container = "_sm-0";
export var table = "_sm-2";
export var tableWrapper = "_sm-1";